import { NoteType } from '../constants/NoteCategoryEnum';

const MOCK_NOTES = [
  {
    noteID: 1,
    noteText: 'VIP access holder - priority parking assigned.',
    noteTypeID: NoteType.AccessHolder,
    contextID: 'ah-100',
    pinned: true,
    userID: 'user-1',
    entityID: 'entity-1',
    updatedBy: null,
    createdBy: {
      name: 'Jane Smith',
      timestamp: '2025-01-15T09:30:00.000Z',
    },
  },
  {
    noteID: 2,
    noteText: 'Credential replaced due to damage.',
    noteTypeID: NoteType.AccessHolder,
    contextID: 'ah-100',
    pinned: false,
    userID: 'user-2',
    entityID: 'entity-1',
    updatedBy: {
      name: 'John Doe',
      timestamp: '2025-01-14T15:00:00.000Z',
    },
    createdBy: {
      name: 'John Doe',
      timestamp: '2025-01-14T10:00:00.000Z',
    },
  },
];

let nextNoteId = 3;

class NotesService {
  constructor(client) {
    this.apiClient = client;
  }

  // GET notes/{noteTypeID}/{contextID}?pinned={pinned}
  // pinned: null = all, true = pinned only, false = unpinned only
  async getNotes(noteTypeID, contextID, pinned = null) {
    let filtered = MOCK_NOTES.filter(
      (n) => n.noteTypeID === noteTypeID
    );
    if (pinned !== null) {
      filtered = filtered.filter((n) => n.pinned === pinned);
    }
    return Promise.resolve({ data: filtered });
  }

  // POST /notes
  // body: { noteText, noteTypeID, contextID, pinned, userID, EntityID }
  async createNote(payload) {
    const newNote = {
      noteID: nextNoteId++,
      noteText: payload.noteText,
      noteTypeID: payload.noteTypeID,
      contextID: payload.contextID,
      pinned: payload.pinned || false,
      userID: payload.userID,
      entityID: payload.entityID,
      updatedBy: null,
      createdBy: {
        name: 'Current User',
        timestamp: new Date().toISOString(),
      },
    };
    return Promise.resolve({ data: newNote });
  }

  // PUT /notes
  // body: { noteID, noteText, pinned, userID, EntityID }
  async updateNote(payload) {
    return Promise.resolve({
      data: {
        noteID: payload.noteID,
        noteText: payload.noteText,
        pinned: payload.pinned,
        updatedBy: {
          name: 'Current User',
          timestamp: new Date().toISOString(),
        },
      },
    });
  }

  // DELETE /notes
  // body: { noteID, userID, EntityID }
  async deleteNote(payload) {
    return Promise.resolve({ status: 200 });
  }
}

export default NotesService;
